import * as a from '../../actions/action_types'

// const INTIAL_STATE = {};
export default (state = [], action) => {
  if (state === undefined) {
    state = null;
  }
  switch (action.type) {
    case a.UPDATE_DATA:
      return action.payload
    default:
      return state;
  }
};
